module.exports = "/images/vendor/vue2vis/dist/zoomExtends.png?5f78e86f895f5a5cc1472cc57db154c5";